import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  LabelList,
} from "recharts";

interface GraphData {
  name: string;
  group1: number;
  group2: number;
  total?: number;
}

interface PerformanceReport {
  graph_data: Record<string, { group1: number; group2: number }>;
}

interface PerformanceBarGraphProps {
  performanceReport: PerformanceReport;
}

interface CustomLabelProps {
  x?: number;
  y?: number;
  width?: number;
  value?: string | number;
}

const CustomLabel: React.FC<CustomLabelProps> = ({
  x = 0,
  y = 0,
  width = 0,
  value = "",
}) => {
  return (
    <text
      x={x + width / 2}
      y={y - 10}
      fill="#000"
      textAnchor="middle"
      dominantBaseline="bottom"
      className="text-sm"
    >
      {value}
    </text>
  );
};

const PerformanceBarGraph: React.FC<PerformanceBarGraphProps> = ({
  performanceReport,
}) => {
  // Transform API data for the bar chart and calculate totals
  const graphData: GraphData[] = Object.entries(
    performanceReport?.graph_data || {},
  ).map(([month, data]) => {
    const group1 = data.group1 || 0;
    const group2 = data.group2 || 0;
    return {
      name: month,
      group1,
      group2,
      total: group1 + group2,
    };
  });

  return (
    <div className="space-y-8">
      <h3 className="text-lg font-semibold mb-2">
        Total # of Top 10 Queries (1-3 vs 4-10)
      </h3>
      <div className="w-1/2">
        <ResponsiveContainer width="100%" height={400}>
          <BarChart
            data={graphData}
            margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
            barSize={50}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" fontSize={12} interval={0} />
            <YAxis
              domain={[
                0,
                (dataMax: number) => Math.ceil((dataMax * 1.2) / 1000) * 1000,
              ]}
            />
            <YAxis
              domain={[
                0,
                (dataMax: number) => Math.ceil((dataMax * 1.2) / 1000) * 1000,
              ]}
            />
            <Tooltip />
            <Legend />
            <Bar
              dataKey="group1"
              stackId="a"
              fill="#4b8cff"
              name="Position 1-3"
            />
            <Bar
              dataKey="group2"
              stackId="a"
              fill="#ff4d4d"
              name="Position 4-10"
            >
              <LabelList
                content={<CustomLabel />}
                dataKey="total"
                position="top"
                offset={10}
              />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default PerformanceBarGraph;
